import { applySnapshot, getSnapshot, types } from 'mobx-state-tree';
import { functionType } from './function.type';

export interface Alert {
  open: boolean;
  title: string;
  message: string;
  isAlert: boolean;
  handleCancel?: () => void;
  handleOK: () => void;
  cancelBtn?: string;
  okBtn: string;
}

const AlertModel = types
  .model('Alert', {
    open: types.optional(types.boolean, false),
    title: types.optional(types.string, ''),
    message: types.optional(types.string, ''),
    isAlert: types.optional(types.boolean, false),
    handleCancel: types.maybeNull(functionType),
    handleOK: types.maybeNull(functionType),
    cancelBtn: types.optional(types.string, ''),
    okBtn: types.optional(types.string, ''),
  })
  .actions((self) => {
    let initialState = {};
    return {
      afterCreate() {
        initialState = getSnapshot(self);
      },
      closeDialog() {
        applySnapshot(self, initialState);
      },
      openAlert(props: Omit<Alert, 'open' | 'isAlert'>) {
        applySnapshot(self, {
          open: true,
          isAlert: true,
          ...props,
        });
      },
    };
  });

export default AlertModel;
